/* ENG-21740 component-local: #00814c is the accessible JSON green, not the Medicus green. */
.m-xml-json-viewer {
  --m-xml-json-viewer-copied-text: #00814c;
  // ENG-21740 Clears the absolute toolbar: --space-2 top offset + its 26px height + a 10px gap.
  // The 26px is emergent from the copy button (16px icon + 2x --space-1 + 2x 1px border), not declared.
  --m-xml-json-viewer-toolbar-clearance: 44px;

  position: relative;
  border: 1px solid var(--border-colour);
  border-radius: var(--radius-md);
  background: var(--grey-lightest);
  overflow: hidden;

  &--wrap {
    // A block element already fills its container; setting width: 100% here
    // ignores any horizontal margin the parent applies (e.g. a card's child
    // inset) and overflows the container to the right. ENG-21348
    max-width: 100%;

    .m-xml-json-viewer__content {
      white-space: pre-wrap;
      overflow-wrap: anywhere;
    }
  }

  &__toolbar {
    position: absolute;
    top: var(--space-2);
    right: var(--space-2);
    display: flex;
    align-items: center;
    gap: var(--space-1-5);
  }

  &__copy {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: var(--space-1);
    appearance: none;
    background: var(--white);
    border: 1px solid var(--border-colour);
    border-radius: var(--radius-default);
    color: var(--text-color-light);
    cursor: pointer;

    &:hover {
      background: var(--hover-background);
    }

    &:focus-visible {
      outline: 3px solid var(--focus-ring);
      outline-offset: 2px;
    }

    &--copied {
      color: var(--m-xml-json-viewer-copied-text);
    }
  }

  &__badge-icon {
    // sits inline before the badge label (badge is inline-block from MBadge)
    vertical-align: middle;
    margin-right: var(--space-0-5);
  }

  &__copy-icon {
    display: block;
  }

  &__content {
    margin: 0;
    padding: var(--m-xml-json-viewer-toolbar-clearance) var(--space-4) var(--space-3);
    overflow-x: auto;
    font-family: "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace;
    font-size: var(--font-size-xs);
    line-height: 1.5;
    color: var(--text-color);
    white-space: pre;
    tab-size: 2;

    // No horizontal padding so per-line tints bleed edge to edge (GitHub-style).
    &--diff {
      padding: var(--m-xml-json-viewer-toolbar-clearance) 0 var(--space-3);
      white-space: normal;
    }
  }

  &__diff-line {
    display: flex;
    align-items: flex-start;
    // Fit the widest line so the row tint spans the full scroll width (100% in wrap mode).
    min-width: 100%;
    width: max-content;

    // No light-green token exists, so the added tint uses --status-green at low opacity.
    &--added {
      background: color-mix(in srgb, var(--status-green) 12%, transparent); // --status-green #008951 @ 12%
    }

    &--removed {
      background: var(--status-light-red);
    }
  }

  &__diff-gutter {
    flex: 0 0 auto;
    width: 2.25em;
    padding-right: 0.5em;
    text-align: right;
    color: var(--text-color-light);
    user-select: none;
  }

  &__diff-line--added &__diff-gutter {
    color: var(--status-green);
  }

  &__diff-line--removed &__diff-gutter {
    color: var(--status-red);
  }

  &__diff-code {
    white-space: pre;
    padding-right: var(--space-4);
  }

  &--wrap &__diff-line {
    width: auto;
  }

  &--wrap &__diff-code {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
}
